import React from 'react'
import Link from 'gatsby-link'
// import Scrollchor from 'react-scrollchor';
import ScrollLink from './scroll-link'


const ListLink = props =>

    <li>
        <Link className="c-btn--link" to={props.to}>
            {props.children}
        </Link>
    </li>

const HeaderNav = props =>
<div>
    <ul className={props.class}>
        <ScrollLink to="#intro" animate={{offset: -120}}>intro</ScrollLink>
        {/* <ListLink to="/sections/">sections</ListLink> */}
        <ScrollLink to="#call" animate={{offset: -120}}>call for abstract</ScrollLink>
        <ScrollLink to="#register" animate={{offset: -120}}>register</ScrollLink>
        <ScrollLink to="#location" animate={{offset: -120}}>location</ScrollLink>
        <ScrollLink to="#directions" animate={{offset: -120}}>directions</ScrollLink>
    </ul>
    <ul className={props.class}>
    <ScrollLink to="#venue" animate={{offset: -120}}>venue</ScrollLink>
    <ScrollLink to="#services" animate={{offset: -120}}>services</ScrollLink>
    <ScrollLink to="#tour" animate={{offset: -120}}>tour</ScrollLink>
    <ScrollLink to="#contact" animate={{offset: -120}}>contact us</ScrollLink>
    <ScrollLink to="#team" animate={{offset: -120}}>organisers</ScrollLink>
    <li>
        <a className="c-btn--link" href="https://www.facebook.com/pzaf2018/" target="_blank">facebook</a>
    </li>
</ul>
</div>

export default HeaderNav



// WEBPACK FOOTER //
// ./src/components/header-nav.js